/**
 * Loads the Google Maps JavaScript API using Google's official inline bootstrap
 * loader, which defines `google.maps.importLibrary` synchronously (avoiding the
 * race where a plain `<script onload>` resolves before the library is ready).
 * Resolves with `window.google.maps`; callers then `await
 * maps.importLibrary('places')`. The key is referrer-restricted and meant to be
 * embedded client-side (standard for the Maps JS API).
 */
let bootstrapped = false;

export function isGoogleMapsReady() {
  return !!window.google?.maps?.importLibrary;
}

// Google's documented bootstrap snippet, parameterized by our options.
function runBootstrap(params) {
  /* eslint-disable */
  (g => {
    var h,
      a,
      k,
      p = 'The Google Maps JavaScript API',
      c = 'google',
      l = 'importLibrary',
      q = '__ib__',
      m = document,
      b = window;
    b = b[c] || (b[c] = {});
    var d = b.maps || (b.maps = {}),
      r = new Set(),
      e = new URLSearchParams(),
      u = () =>
        h ||
        (h = new Promise(async (f, n) => {
          await (a = m.createElement('script'));
          e.set('libraries', [...r] + '');
          for (k in g)
            e.set(
              k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()),
              g[k]
            );
          e.set('callback', c + '.maps.' + q);
          a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
          d[q] = f;
          a.onerror = () => (h = n(Error(p + ' could not load.')));
          a.nonce = m.querySelector('script[nonce]')?.nonce || '';
          m.head.append(a);
        }));
    d[l]
      ? console.warn(p + ' only loads once. Ignoring:', g)
      : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
  })(params);
  /* eslint-enable */
}

export function loadGoogleMaps(apiKey) {
  if (!apiKey) return Promise.reject(new Error('Missing Google Maps API key'));
  if (!isGoogleMapsReady() && !bootstrapped) {
    bootstrapped = true;
    runBootstrap({ key: apiKey, v: 'weekly', language: 'es', region: 'MX' });
  }
  // importLibrary is defined synchronously by the bootstrap above.
  return Promise.resolve(window.google.maps);
}
